const fonts = {
    body: "TT Travels",
    heading: "TT Travels",
};
export default fonts;
//# sourceMappingURL=fonts.js.map